import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  ProfileIconButton,
  StyledLogOutMenu,
  StyledPersonIcon,
  UserName,
} from "./ButtonStyles";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(accounts[0]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async (logoutType) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      await instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <>
      <ProfileIconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <StyledPersonIcon />
        <UserName>{user?.name ?? "Guest"}</UserName>
      </ProfileIconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <StyledLogOutMenu onClick={async () => await handleLogout("redirect")}>
          <Typography fontSize={20}>Logout</Typography>
        </StyledLogOutMenu>
      </Menu>
    </>
  );
};
